module.exports = __webpack_public_path__ + "img/customs_white.172e0cf2.svg";